<template>
  <div class="content-wrapper">
    <template v-if="Object.keys(groupOrderDetails).length">
      <h2 class="page-titles">
        {{ groupOrderDetails.name }}
      </h2>

      <div class="group-order-success">
        <div class="success editorial">
          <p class="group-order-success-title">
            Success! Your redemption page has been created.
          </p>

          <span>
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="27" cy="27" r="27" fill="#68C67E" />
              <path d="M16 25.5238L24.8889 36L36 16" stroke="#232220" />
            </svg>
          </span>
        </div>

        <div class="flex flex-col items-center gap-3">
          <div class="header">
            <p>
              Here’s the link to your redemption page
              <strong>{{ groupOrderDetails.name }}</strong>
            </p>
          </div>
          <div class="link-content">
            <CopyBanner
              :text="groupOrderDetails.recipientCollectionPaigeUrl"
              @click="doCopy"
            />
          </div>
        </div>

        <div class="button-container">
          <button
            @click="handleViewRedemptionPage"
            class="whitebutton-gemnote   button-gemnote--small"
          >
            <span>View Redemption page</span>
          </button>
          <button
            @click="handleNewRedemption"
            class="button-gemnote button-gemnote--small"
          >
            <span>New Redemption Page</span>
          </button>
        </div>
      </div>
    </template>
    <template v-else>
      <h2 class="page-titles">Redemption page details not found</h2>
      <div class="arrow-link margin">
        <router-link :to="{ name: 'report' }">
          <img
            class="arrow left-arrow"
            src="../../assets/gemnote-back-arrow.svg"
          />
          <span>Back to your Dashboard</span>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts } from '../../helpers'
import CopyBanner from '@/components/Universal/CopyBanner'

export default {
  name: 'GroupOrderSuccess',
  components: { CopyBanner },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.commit('groupOrder/CREATING_GROUP_ORDER_STEP', 1)
  },
  methods: {
    doCopy() {
      this.$copyText(this.groupOrderDetails.recipientCollectionPaigeUrl).then(
        () => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'success',
            messages: [`Redemption page link copied.`]
          })
        },
        error => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`Can not copy redemption page link.`]
          })
          console.log(error)
        }
      )
    },
    async handleNewRedemption() {
      this.$store.commit('groupOrder/SET_GROUP_ORDER_DETAILS', {})
      this.$router.push({ name: 'GroupOrderCreate' })
    },
    async handleViewRedemptionPage() {
      window.open(this.groupOrderDetails.recipientCollectionPaigeUrl, '_blank')
    }
  },
  computed: {
    ...mapState({
      groupOrderDetails: state => state.groupOrder.groupOrderDetails
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.page-titles {
  font-size: 2rem;
}

.arrow-link {
  margin-top: 4rem;
}

.group-order-success {
  border: 1px solid #232220;
  border-radius: 12px;
  display: flex;
  gap: 2rem;
  flex-direction: column;
  padding: 2rem 1rem;

  .header {
    p {
      font-size: 0.983rem;
      font-weight: 400;
    }
  }

  .link-content {
    width: 70%;
    margin: 0 auto 0 auto;
    display: flex;
    justify-content: center;

    span {
      font-size: 0.813rem;
      border: 1px solid $main-6;
      padding: 1rem 1rem;
    }
  }
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  text-align: left;

  p {
    font-size: 1.45rem;
    font-weight: normal;
    padding-top: 6px;
    margin-left: 10px;
    color: #232220;
  }
}

.button-container {
  margin: 0.5rem 0 1rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  .button-gemnote--small {
    text-decoration: none;
    padding: 0px 2rem !important;
  }
}

@media (max-width: 1100px) {
  .group-order-success {
    .link-content {
      margin: 0.5rem 0rem;

      span {
        padding: 0.5rem 0.5rem;
      }
    }
  }
}
@media (max-width: 800px) {
  .button-container {
    flex-direction: column;
    button {
      width: 100%;
    }
  }
  .link-content {
    width: 100% !important;
  }
  .success {
    p {
      text-align: center !important;
    }
  }
}
</style>
